import { ActionService } from 'dashboard-services/services';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';
import { globalActions } from 'primary-components';

export default (() => {
  
  const ON_CHANGE = 'ON_CHANGE_INSIGHT_TEMPLATES'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')
  
  const ON_CHANGE_LIST = 'ON_CHANGE_LIST_INSIGHT_TEMPLATES'
  const onChangeList = ActionService.makeActionCreator(ON_CHANGE_LIST, 'value', 'name', 'listName', 'index')
  
  const ON_CHANGE_SELECTED_PARAMS = 'ON_CHANGE_SELECTED_PARAMS_INSIGHT_TEMPLATES'
  const onChangeSelectedParams = ActionService.makeActionCreator(ON_CHANGE_SELECTED_PARAMS, 'value', 'name')
  
  const ON_CHANGE_SELECTED_PARAM = 'ON_CHANGE_SELECTED_PARAM_INSIGHT_TEMPLATES'
  const onChangeSelectedParam = ActionService.makeActionCreator(ON_CHANGE_SELECTED_PARAM, 'value', 'name', 'paramName')

  const CLEAR = 'CLEAR_INSIGHT_TEMPLATES'
  const clear = ActionService.makeActionCreator(CLEAR)

  const getTemplateDefinitionCall = ({ searchTemplateCall, getTemplateContentCall, templateName, groupName, navigate }) => dispatch => {
    let fileInfo;
    const getFile = ({ items = [] }) => {
      if(!items[0]) {
        dispatch(globalActions.getMessageStore()).error("Insight template not found.")
        navigate(DashboardLinkFactory.insight.templates({ baseUrl: "" }))
        return;
      }
      fileInfo = items[0]
      return getTemplateContentCall({ id: fileInfo?.fid })
    }
    return searchTemplateCall({ query: `fields.insightTemplate=true&name=${templateName}.json&groupName=${groupName}` })
      .then(getFile)
      .then(resp => ({
        file: resp,
        fileInfo
      }))
  }

  const getTask = ({ taskName, taskGroup, searchTasksCall }) =>
    searchTasksCall({ query: `readableName=${taskName}&groupName=${taskGroup}` })
      .then(({ items = [] } = {}) => items[0])

  const DEFAULT_CONFIGURATION_SECTIONS = [{
    label: "Source",
    value: "Source"
  }, {
    label: "Parameters",
    value: "Parameters"
  }]

  return {
    onChange,
    ON_CHANGE,
    ON_CHANGE_SELECTED_PARAMS,
    onChangeSelectedParams,
    ON_CHANGE_SELECTED_PARAM,
    onChangeSelectedParam,
    getTemplateDefinitionCall,
    getTask,
    clear,
    CLEAR,
    onChangeList,
    ON_CHANGE_LIST,
    DEFAULT_CONFIGURATION_SECTIONS
  }
})()
